export default __webpack_public_path__ + "static/ASLA_Tenza_1a-a1e730fbe1fa896d44b006d9fce8cd46.png";